var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar-button',{attrs:{"icon":"mdi-file-replace-outline","tooltip":_vm.tooltip ? _vm.tooltip : 'Apply bulk operations to selected contents'},on:{"click":_vm.openBulkUploadDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }